module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('div', {
    attrs: {
      "id": "overlay"
    }
  }, [_c('div', {
    staticClass: "spinner"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Loading...")])]) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "p-grid justify-content-end"
  }, [_c('div', {
    staticClass: "p-col"
  }, [_c('Button', {
    staticClass: "p-button p-component p-button-success addNewBtn btn-btm-0",
    attrs: {
      "icon": "pi pi-plus",
      "label": "NEW"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openAddDialog.apply(null, arguments)
      }
    }
  })], 1)]), _vm._v(" "), _c('Dialogs', {
    style: ({
      width: '50vw',
      maxHeight: '90vh'
    }),
    attrs: {
      "header": "Activity/Task",
      "visible": _vm.addDisplayBasic,
      "modal": true,
      "closable": false,
      "contentStyle": {
        'overflow-y': 'auto',
        'max-height': '70vh'
      }
    },
    on: {
      "update:visible": function($event) {
        _vm.addDisplayBasic = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('Button', {
          staticClass: "p-button-raised p-button",
          attrs: {
            "label": _vm.editing ? 'Update' : 'Add'
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.addProduct.apply(null, arguments)
            }
          }
        }), _vm._v(" "), (!_vm.editing) ? _c('Button', {
          staticClass: "p-button-raised p-button-primary",
          attrs: {
            "label": "Add & New"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.addAndNewProduct.apply(null, arguments)
            }
          }
        }) : _vm._e(), _vm._v(" "), _c('Button', {
          staticClass: "p-button-raised p-button-danger",
          attrs: {
            "label": "Cancel"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.addCancel.apply(null, arguments)
            }
          }
        })]
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "source"
    }
  }, [_vm._v("Activity Type")]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "id": "source",
      "options": _vm.sourceList,
      "optionLabel": "value",
      "placeholder": "Select Activity Type"
    },
    model: {
      value: (_vm.taskType),
      callback: function($$v) {
        _vm.taskType = $$v
      },
      expression: "taskType"
    }
  })], 1), _vm._v(" "), (_vm.taskType && _vm.taskType.value === 'call') ? _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "callTypeId"
    }
  }, [_vm._v("Call type"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "options": _vm.callTypeOptions,
      "optionLabel": "label",
      "optionValue": "value",
      "placeholder": "Select Call Type"
    },
    model: {
      value: (_vm.callType),
      callback: function($$v) {
        _vm.callType = $$v
      },
      expression: "callType"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "taskname"
    }
  }, [_vm._v("Task Name"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "taskname"
    },
    model: {
      value: (_vm.taskName),
      callback: function($$v) {
        _vm.taskName = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "taskName"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "clientid"
    }
  }, [_vm._v("Client Id")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "clientid"
    },
    on: {
      "keypress": function($event) {
        return _vm.isNumber($event)
      }
    },
    model: {
      value: (_vm.clientId),
      callback: function($$v) {
        _vm.clientId = $$v
      },
      expression: "clientId"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "taskDueDate"
    }
  }, [_vm._v("Task Due Date")]), _vm._v(" "), _c('InputMask', {
    attrs: {
      "mask": "9999-99-99",
      "id": "taskDueDate"
    },
    on: {
      "keypress": function($event) {
        return _vm.isNumber($event)
      }
    },
    model: {
      value: (_vm.taskDueDate),
      callback: function($$v) {
        _vm.taskDueDate = $$v
      },
      expression: "taskDueDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "productId"
    }
  }, [_vm._v("Product")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "productId"
    },
    model: {
      value: (_vm.productId),
      callback: function($$v) {
        _vm.productId = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "productId"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "stageId"
    }
  }, [_vm._v("Stage Id")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "stageId"
    },
    model: {
      value: (_vm.stageId),
      callback: function($$v) {
        _vm.stageId = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "stageId"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "taskStatus"
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "taskStatus"
    },
    model: {
      value: (_vm.taskStatus),
      callback: function($$v) {
        _vm.taskStatus = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "taskStatus"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "priority"
    }
  }, [_vm._v("Priority")]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "id": "priority",
      "options": _vm.priorityList,
      "optionLabel": "value",
      "placeholder": "Select Priority"
    },
    model: {
      value: (_vm.priorityName),
      callback: function($$v) {
        _vm.priorityName = $$v
      },
      expression: "priorityName"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "repeat"
    }
  }, [_vm._v("Repeat")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "repeat"
    },
    model: {
      value: (_vm.repeat),
      callback: function($$v) {
        _vm.repeat = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "repeat"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "reminderType"
    }
  }, [_vm._v("reminderType")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "reminderType"
    },
    model: {
      value: (_vm.reminderType),
      callback: function($$v) {
        _vm.reminderType = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "reminderType"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "reminderDate"
    }
  }, [_vm._v("Reminder Date")]), _vm._v(" "), _c('InputMask', {
    attrs: {
      "mask": "9999-99-99",
      "id": "reminderDate"
    },
    model: {
      value: (_vm.reminderDate),
      callback: function($$v) {
        _vm.reminderDate = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "reminderDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "reminderTime"
    }
  }, [_vm._v("Reminder Time")]), _vm._v(" "), _c('DatePicker', {
    attrs: {
      "type": "time",
      "id": "reminderTime",
      "placeholder": "Select time (HH:mm)",
      "time-picker-options": {
        start: '08:00',
        step: '00:30',
        end: '20:00'
      },
      "format": "HH:mm",
      "value-type": "format"
    },
    model: {
      value: (_vm.reminderTime),
      callback: function($$v) {
        _vm.reminderTime = $$v
      },
      expression: "reminderTime"
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "p-d-block p-mt-1 p-text-secondary"
  }, [_vm._v("\n            Enter time in 24-hour format (e.g., 14:30)\n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "description"
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('Textarea', {
    staticStyle: {
      "resize": "vertical",
      "min-height": "75px",
      "max-height": "150px"
    },
    attrs: {
      "id": "description",
      "rows": "3"
    },
    model: {
      value: (_vm.description),
      callback: function($$v) {
        _vm.description = $$v
      },
      expression: "description"
    }
  })], 1)])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3033353c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/crmDialog/crmTaskDialog.vue
// module id = 2124
// module chunks = 0